import { useEffect } from "react";
import _ from "lodash";
import { formStates } from "../../store/formStates";
import { dispatch } from "../../store/store";
import { FORM_PRESERVATION_DELAY } from "./config";
import { Path } from "../../store/formStates/utilities";
import { history } from "../../history";

const { actions } = formStates;
const defaultCondition = () => true;

export const usePreserveForm = (formValues, options = {}) => {
  options = {
    condition: options.condition || defaultCondition,
    isRecovered: Boolean(options.isRecovered),
  };

  const set = _.throttle((data) => {
    dispatch(
      actions.set({
        data,
      }),
    );
  }, FORM_PRESERVATION_DELAY);

  const clear = () => {
    dispatch(actions.reset());
  };

  useEffect(() => {
    if (formValues && options.condition()) {
      set(formValues);

      if (options.isRecovered && Path.isMarkedRecovered(Path.create())) {
        history.replace(
          Path.unmarkRecovered(window.location.pathname),
          history.location.state,
        );
      }
    }
  }, [formValues, options.isRecovered]);

  useEffect(() => {
    return () => {
      clear();
    };
  }, []);

  return {
    set,
    clear,
  };
};
